import React from 'react';
import { Grid, MenuItem, TextField } from '@mui/material';
import type { FiscalFormState } from './nfseFiscalForm';

export type FieldKitProps = {
  form: FiscalFormState;
  fieldErrors: Record<string, string>;
  onChange: (
    key: keyof FiscalFormState
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

type Option = { value: string; label: string };

/** Fábrica de campos MUI ligados ao estado do formulário fiscal. */
export function makeFields({ form, fieldErrors, onChange }: FieldKitProps) {
  const helper = (key: keyof FiscalFormState, hint: string) => fieldErrors[key] || hint;

  const text = (
    key: keyof FiscalFormState,
    label: string,
    hint: string,
    extra: Record<string, unknown> = {},
    md = 4
  ) => (
    <Grid item xs={12} md={md} key={key}>
      <TextField
        fullWidth
        label={label}
        value={form[key] as string}
        onChange={onChange(key)}
        error={!!fieldErrors[key]}
        helperText={helper(key, hint)}
        {...extra}
      />
    </Grid>
  );

  const select = (
    key: keyof FiscalFormState,
    label: string,
    options: ReadonlyArray<Option>,
    hint: string,
    opts: { allowEmpty?: boolean; md?: number } = {}
  ) => (
    <Grid item xs={12} md={opts.md ?? 6} key={key}>
      <TextField
        select
        fullWidth
        label={label}
        value={form[key] as string}
        onChange={onChange(key)}
        error={!!fieldErrors[key]}
        helperText={helper(key, hint)}
        SelectProps={{ displayEmpty: true }}
      >
        {opts.allowEmpty !== false && (
          <MenuItem value="">
            <em>(Não salvo no billing — escolha)</em>
          </MenuItem>
        )}
        {options.map(o => (
          <MenuItem key={`${key}-${o.value}`} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  );

  return { text, select, helper };
}
